<!--
트래킹검수 > 검수화면 > 검수완료 리스트 컴포넌트
------------------------------------
-->
<template>
    <div>
        <!-- 검수완료 리스트-->
        <div class="uk-text-medium3">
            <i class="material-icons" >
                done_all
            </i>
            검수완료 ({{ otherProds.length }})
        </div>

        <div class="uk-card uk-card-default">

            <table class="prod-info">
                <colgroup>
                    <col style="width: 11rem">

                    <col style="width: 5rem">
                    <col>
                    <col>
                    <col>
                    <col>

                    <col>
                    <col>
                    <col>
                    <col>
                    <col style="width: 11rem">

                </colgroup>
                <thead>
                <tr>

                    <th>
                        <i class="material-icons">link</i>
                        상세
                    </th>

                    <th>
                        <i class="material-icons">image</i>
                    </th>
                    <th class="name">
                        상품명
                    </th>
                    <th>
                        색상
                    </th>
                    <th>
                        사이즈
                    </th>
                    <th>
                        유통기한
                    </th>
                    <th>
                        수량
                    </th>


                    <th>
                        배송단계
                    </th>
                    <th>
                        수취인
                    </th>
                    <th>
                        <i class="material-icons">location_on</i>
                        보관장소
                    </th>
                    <th>
                        <i class="material-icons">print</i>
                        보관라벨
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(prod, index) in otherProds"
                    :key="prod.id"
                >
                    <td>
                        <button
                            type="button"
                            class="uk-button uk-button-dg-w-lg uk-button-on-dg-w-dg uk-button-small"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="'/prods/' + prod.id"
                            data-target="_blank"
                        >
                            <i class="material-icons">link</i>
                            상세
                        </button>
                    </td>

                    <td>
                        <img-zoom :src="prod.img_url" disable-preview style="width: 4rem; height: 4rem"></img-zoom>
                    </td>
                    <td class="name">
                        {{ prod.name }}
                    </td>
                    <td>
                        {{ prod.color }}
                    </td>
                    <td>
                        {{ prod.size }}
                    </td>
                    <td>
                        {{ prod.expiration_date }}
                    </td>
                    <td>
                        {{ prod.amount }}
                    </td>

                    <td>
                        {{ prod.state_text }}
                        <div class="uk-text-center uk-margin-top" v-show="prod.state === 62">
                            <button
                                type="button"
                                class="uk-button uk-button-primary"
                                @click="$emit('packing', prod.house_id)"
                            >
                                <i class="material-icons">tab</i>
                                <span class="text">패킹작업</span>
                            </button>
                        </div>
                    </td>
                    <td>
                        {{ prod.h_name }}
                    </td>
                    <td>
                        {{ prod.storage }}
                    </td>
                    <td>
                        <button
                            type="button"
                            class="uk-button uk-button-dg-w-lg uk-button-on-dg-w-dg uk-button-small"
                            @click="printStoreLabel(arguments, prod.id)"
                            title="보관라벨을 출력합니다"
                        >
                            <i class="material-icons">print</i>
                            <span class="text">PRINT</span>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>

    </div>
</template>

<script>
    export default {
        components: {
            'img-zoom': require('../../common/img-zoom.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 검수완료 상품리스트
             */
            otherProds: {
                type: Array,
                default: null,
            },
        },
        data: function () {
            return {
            };
        },
        computed: {

        },

        methods: {
            /**
             * 보관라벨 출력
             * @param args
             * @param prod_id
             */
            printStoreLabel(args, prod_id) {
                console.log(prod_id);
                $.app.print.store_label(args, prod_id);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .prod-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .material-icons {
            vertical-align: middle;
            font-size: 1.5rem;
        }

        th {
            background-color: #fafafa;
        }

        th, td {
            font-size: 1rem;
            text-align: center;
            padding: 5px;
            font-weight: normal;

            &.name {
                text-align: left;

            }

            border: 1px solid #cfcfcf;
        }

        tr:hover td {
            //background-color: #e6f5ff;
            background-color: #eee;
        }

    }
</style>